/* AULBERY — Instagram carousel (design I4)
   Moved 1:1 from the inline <script> in sections/as-instagram.liquid (v13
   structural). Each section root carries data-as-instagram plus data-*
   attributes for the values that used to be Liquid-interpolated into the
   script. The clone-builder branch (guarded by !clones.length) is kept as it
   was; Liquid renders the clones whenever blocks exist, so it does not run
   today. Adds a shopify:section:unload cleanup. */
(function () {
  function num(root, key, fallback) {
    var v = parseFloat(root.dataset[key]);
    return isNaN(v) ? fallback : v;
  }
  function bool(root, key, fallback) {
    var v = root.dataset[key];
    if (v === 'true') return true;
    if (v === 'false') return false;
    return fallback;
  }

  function initIg(root) {
    if (!root || root.dataset.asiInit === '1') return;
    root.dataset.asiInit = '1';

    var autoHoldMs = num(root, 'autoHoldMs', 1400);
    var dragHoldMs = num(root, 'dragHoldMs', 400);
    var overlayOnDrag = bool(root, 'overlayOnDrag', true);
    var autoOverlay = bool(root, 'autoOverlay', true);
    var settleEpsilon = num(root, 'settleEpsilon', 0.5);
    var settleFrames = num(root, 'settleFrames', 4);
    var settleMinMs = num(root, 'settleMinMs', 140);
    var settleMaxMs = num(root, 'settleMaxMs', 1200);
    var loopResetMs = num(root, 'loopResetMs', 60);
    var dragThreshold = num(root, 'dragThreshold', 3);
    var autoTickMs = num(root, 'autoTickMs', 250);
    var inviewThreshold = num(root, 'inviewThreshold', 35) / 100;

    var track = root.querySelector('[data-asi-track]');
    var posts = Array.prototype.slice.call(root.querySelectorAll('[data-asi-post]'));
    var clones = Array.prototype.slice.call(root.querySelectorAll('[data-asi-clone]'));
    var segs = Array.prototype.slice.call(root.querySelectorAll('[data-asi-seg]'));
    var prevBtn = root.querySelector('[data-asi-prev]');
    var nextBtn = root.querySelector('[data-asi-next]');
    if (!track || !posts.length) return;

    var active = 0;
    var physicalIndex = 0;
    var loopResetTimer = null;
    var overlayArrivalToken = 0;

    // A forward-only buffer. The first cloned post appears after the last
    // real post, so the carousel never animates backwards at the seam.
    var trailingEdge = track.querySelector('.asi-edge:last-child');
    if (!clones.length && posts.length > 1) {
      posts.forEach(function (post, i) {
        post.dataset.asiLogical = String(i);
        var clone = post.cloneNode(true);
        clone.classList.add('asi-clone');
        clone.classList.remove('is-on', 'is-lit');
        clone.dataset.asiClone = '1';
        clone.dataset.asiLogical = String(i);
        clone.removeAttribute('data-shopify-editor-block');
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        var sourceImages = post.querySelectorAll('img');
        var cloneImages = clone.querySelectorAll('img');
        Array.prototype.forEach.call(cloneImages, function (img, imageIndex) {
          var sourceImage = sourceImages[imageIndex];
          var readySrc = sourceImage ? (sourceImage.currentSrc || sourceImage.src) : '';
          if (readySrc) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = readySrc;
          }
          img.loading = 'eager';
          img.fetchPriority = i < 2 ? 'high' : 'auto';
        });
        track.insertBefore(clone, trailingEdge || null);
        Array.prototype.forEach.call(cloneImages, function (img) {
          if (typeof img.decode === 'function') img.decode().catch(function () {});
        });
        clones.push(clone);
      });
    }
    posts.forEach(function (post, i) { post.dataset.asiLogical = String(i); });
    var slides = posts.concat(clones);
    var initialAutoPending = true;

    function markManualInteraction() {
      initialAutoPending = false;
      overlayArrivalToken += 1;
    }

    function setActive(i) {
      if (i === active || i < 0 || i >= posts.length) return;
      active = i;
      posts.forEach(function (p, n) { p.classList.toggle('is-on', n === i); });
      segs.forEach(function (s, n) { s.classList.toggle('is-on', n === i); });
      if (prevBtn) prevBtn.disabled = i === 0;
      if (nextBtn) nextBtn.disabled = i === posts.length - 1;
    }

    // measured against the track's own box. offsetLeft resolves against the
    // nearest positioned ancestor, which is not the track, so it carried a
    // constant page offset and the first post could never win.
    function trackMid() {
      var r = track.getBoundingClientRect();
      return r.left + r.width / 2;
    }

    function nearestPhysical() {
      var mid = trackMid();
      var best = 0;
      var bestD = Infinity;
      slides.forEach(function (p, i) {
        var r = p.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function goToPhysical(i, behavior) {
      var p = slides[i];
      if (!p) return;
      var r = p.getBoundingClientRect();
      var delta = (r.left + r.width / 2) - trackMid();
      track.scrollTo({ left: track.scrollLeft + delta, behavior: behavior || 'smooth' });
      physicalIndex = i;
    }

    function goTo(i) {
      goToPhysical(i, 'smooth');
    }

    function jumpToOriginal(i) {
      if (!posts[i]) return;
      var from = slides[nearestPhysical()];
      var transferLit = from && from.classList.contains('is-lit');
      var previousBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      goToPhysical(i, 'auto');
      setActive(i);
      if (transferLit) {
        slides.forEach(function (p) { p.classList.toggle('is-lit', p === posts[i]); });
      }
      window.requestAnimationFrame(function () {
        track.style.scrollBehavior = previousBehavior || '';
      });
    }

    function jumpToBufferedCopy(i) {
      var target = posts.length + (i % posts.length);
      var previousBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      goToPhysical(target, 'auto');
      setActive(i % posts.length);
      window.requestAnimationFrame(function () {
        track.style.scrollBehavior = previousBehavior || '';
      });
    }

    function normalizeLoopBuffer() {
      var at = nearestPhysical();
      if (at < posts.length * 2) return false;
      // Never carry a fading class from one physical card to another. The
      // overlay is started only after this invisible normalization.
      slides.forEach(function (p) { p.classList.remove('is-lit'); });
      jumpToBufferedCopy(at % posts.length);
      return true;
    }

    // only the post you actually touch or drag lights up
    var litTimer;
    var autoLighting = false;
    function lightUp(el) {
      if (!el) return;
      slides.forEach(function (p) { p.classList.toggle('is-lit', p === el); });
      clearTimeout(litTimer);
    }
    function lightDown(delay) {
      clearTimeout(litTimer);
      litTimer = setTimeout(function () {
        slides.forEach(function (p) { p.classList.remove('is-lit'); });
      }, delay);
    }
    function lightForAuto(el) {
      if (!el) return;
      autoLighting = true;
      slides.forEach(function (p) { p.classList.toggle('is-lit', p === el); });
      clearTimeout(litTimer);
      litTimer = setTimeout(function () {
        autoLighting = false;
        slides.forEach(function (p) { p.classList.remove('is-lit'); });
      }, autoHoldMs);
    }

    function lightWhenTrackSettles() {
      var token = ++overlayArrivalToken;
      var startedAt = performance.now();
      var lastLeft = track.scrollLeft;
      var stableFrames = 0;

      function check() {
        if (token !== overlayArrivalToken) return;
        var now = performance.now();
        var left = track.scrollLeft;
        if (Math.abs(left - lastLeft) < settleEpsilon) {
          stableFrames += 1;
        } else {
          stableFrames = 0;
          lastLeft = left;
        }

        // Waiting at least the minimum settle time prevents the first quiet
        // frames before a smooth scroll begins from being mistaken for the
        // end of motion.
        if ((stableFrames >= settleFrames && now - startedAt >= settleMinMs) || now - startedAt >= settleMaxMs) {
          if (normalizeLoopBuffer()) {
            // Let the instant buffer jump paint before beginning one clean
            // overlay fade on the stationary replacement card.
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (token === overlayArrivalToken) lightForAuto(slides[nearestPhysical()]);
              });
            });
          } else {
            lightForAuto(slides[nearestPhysical()]);
          }
          return;
        }
        window.requestAnimationFrame(check);
      }
      window.requestAnimationFrame(check);
    }
    function anyLit() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-lit')) return true;
      }
      return false;
    }
    function postFrom(e) {
      return e.target && e.target.closest ? e.target.closest('[data-asi-post]') : null;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (anyLit() && !autoLighting) lightDown(dragHoldMs);
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        physicalIndex = nearestPhysical();
        setActive(physicalIndex % posts.length);
        ticking = false;
      });

      // The third rendered set is a safety buffer. As soon as a post in it
      // settles, jump to the identical already-loaded post in the middle
      // set. There is still a full set ahead, so no blank edge can appear.
      clearTimeout(loopResetTimer);
      loopResetTimer = setTimeout(normalizeLoopBuffer, loopResetMs);
    });

    // Modern browsers provide an exact end-of-scroll event; the short
    // debounce above remains as a fallback for older mobile browsers.
    if ('onscrollend' in track) {
      track.addEventListener('scrollend', normalizeLoopBuffer);
    }

    track.addEventListener('touchstart', function (e) {
      markManualInteraction();
      if (overlayOnDrag) lightUp(postFrom(e));
    }, { passive: true });
    track.addEventListener('touchend', function () {
      lightDown(dragHoldMs);
    });

    segs.forEach(function (s) {
      s.addEventListener('click', function () {
        markManualInteraction();
        goTo(parseInt(s.dataset.asiSeg, 10));
      });
    });

    posts.forEach(function (p, i) {
      p.addEventListener('click', function () {
        markManualInteraction();
        if (i !== active) {
          goTo(i);
          return;
        }
        var url = p.dataset.url;
        if (url) window.open(url, '_blank', 'noopener');
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () {
      markManualInteraction();
      goTo(Math.max(0, active - 1));
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      markManualInteraction();
      goTo(Math.min(posts.length - 1, active + 1));
    });

    // drag to scroll — while dragging every overlay shows
    var down = false, startX = 0, startScroll = 0, moved = false, dragEl = null;
    track.addEventListener('mousedown', function (e) {
      markManualInteraction();
      down = true; moved = false;
      dragEl = postFrom(e);
      startX = e.pageX; startScroll = track.scrollLeft;
      track.style.scrollBehavior = 'auto';
    });
    function onWindowMouseMove(e) {
      if (!down) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > dragThreshold) {
        moved = true;
        if (overlayOnDrag) lightUp(dragEl);
      }
      track.scrollLeft = startScroll - dx;
    }
    function onWindowMouseUp() {
      if (!down) return;
      down = false;
      lightDown(dragHoldMs);
      track.style.scrollBehavior = 'smooth';
      if (moved) goToPhysical(nearestPhysical(), 'smooth');
    }
    window.addEventListener('mousemove', onWindowMouseMove);
    window.addEventListener('mouseup', onWindowMouseUp);

    setActive(0);

    // Auto-advance can be off, mobile-only, or enabled on all screens.
    var autoMs = num(root, 'autoMs', 5) * 1000;
    var autoMode = root.dataset.autoMode || 'off';
    var autoTimer = null;
    var mq = window.matchMedia('(max-width: 749px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var inView = true;
    var io = null;

    function autoAllowed() {
      return autoMode === 'all' || (autoMode === 'mobile' && mq.matches);
    }

    function autoStop() {
      if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
    }

    function autoAdvance() {
      var currentPhysical = initialAutoPending ? 0 : nearestPhysical();
      initialAutoPending = false;
      var nextPhysical = currentPhysical + 1;
      if (nextPhysical >= slides.length) {
        jumpToBufferedCopy(currentPhysical % posts.length);
        nextPhysical = posts.length + ((currentPhysical + 1) % posts.length);
      }

      goToPhysical(nextPhysical, 'smooth');
      var next = nextPhysical % posts.length;
      setActive(next);
      if (autoOverlay) {
        // Smooth-scroll duration varies by browser and device. Start the
        // overlay only after the track has genuinely stopped, including any
        // invisible loop-buffer reset that happens at the seam.
        lightWhenTrackSettles();
      }
    }
    function autoStart() {
      autoStop();
      if (!autoAllowed() || !inView || reduce.matches || posts.length < 2) return;
      var dueAt = Date.now() + autoMs;
      autoTimer = window.setInterval(function () {
        if (!autoAllowed() || !inView || reduce.matches) return;
        if (Date.now() < dueAt) return;
        autoAdvance();
        dueAt = Date.now() + autoMs;
      }, autoTickMs);
    }

    if (window.IntersectionObserver) {
      io = new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) { autoStart(); } else { autoStop(); }
      }, { threshold: inviewThreshold });
      io.observe(root);
    }
    track.addEventListener('touchstart', autoStop, { passive: true });
    track.addEventListener('touchend', autoStart);
    track.addEventListener('mousedown', autoStop);
    window.addEventListener('mouseup', autoStart);
    if (mq.addEventListener) mq.addEventListener('change', autoStart);
    autoStart();

    root.asInstagramCleanup = function () {
      autoStop();
      clearTimeout(litTimer);
      clearTimeout(loopResetTimer);
      overlayArrivalToken += 1;
      window.removeEventListener('mousemove', onWindowMouseMove);
      window.removeEventListener('mouseup', onWindowMouseUp);
      window.removeEventListener('mouseup', autoStart);
      if (mq.removeEventListener) mq.removeEventListener('change', autoStart);
      if (io) io.disconnect();
      root.dataset.asiInit = '';
    };
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-as-instagram]'), initIg);
  }

  function onUnload(e) {
    var scope = e && e.target && e.target.querySelectorAll ? e.target : null;
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-as-instagram]'), function (root) {
      if (typeof root.asInstagramCleanup === 'function') root.asInstagramCleanup();
    });
  }

  // the asset is loaded once per section instance; bind the document
  // listeners only the first time it runs
  if (document.documentElement.dataset.asInstagramBound !== '1') {
    document.documentElement.dataset.asInstagramBound = '1';
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:section:unload', onUnload);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

